import Cookies from 'js-cookie';
import api from '../../services/api';
import { jwtDecode } from 'jwt-decode';
import { parseConfigValue } from './customerConfigHelper';

// The signed-in user's own settings (UserConfiguration), the user-level counterpart of customerConfigHelper.js.
export function loadUserConfigs() {
  const token = Cookies.get('accessToken');
  if (!token) return Promise.resolve(null);
  const decodedToken = jwtDecode(token);
  let userId = decodedToken.UserIdentifier;
  return api.get('User/me/configurations')
    .then(response => {
      let returnData = JSON.stringify({
        data: response.data,
        expiry: Date.now() + 6 * 60 * 60 * 1000, // 6 hours
      });
      localStorage.setItem(userId + '-' + 'UserConfig', returnData);
      return response.data;
    })
    .catch(error => {
      console.error('API request error:', error); // eslint-disable-line no-console
      localStorage.removeItem(userId + '-' + 'UserConfig'); // may be out of date, e.g. after a save
      return null;
    });
}

export function getUserConfigValue(configs, configType) {
  if (!configs) return '';
  const match = configs.find(c => c.userConfigurationType.type === configType);
  return match ? parseConfigValue(match.value) : '';
}

export async function getUserConfig(configType) {
  const configs = await loadUserConfigsCached();
  return getUserConfigValue(configs, configType);
}

export async function loadUserConfigsCached() {
  const token = Cookies.get('accessToken');
  if (!token) return null;
  const decodedToken = jwtDecode(token);
  let userId = decodedToken.UserIdentifier;

  let storedConfigs = localStorage.getItem(userId + '-' + 'UserConfig');
  if (storedConfigs) {
    let parsedConfigs = JSON.parse(storedConfigs);
    if (parsedConfigs.expiry && Date.now() <= parsedConfigs.expiry) {
      return parsedConfigs.data;
    }
    localStorage.removeItem(userId + '-' + 'UserConfig');
  }

  return await loadUserConfigs();
}

export function getUserConfigTypeId(configType) {
  switch (configType) {
    case "EnableReferenceInTimeRegistration":
      return 1;
    default:
      return 0;
  }
}
